import './App.css';
import AppSolution from './AppSolution/AppSolution';

function App() {
  return <AppSolution />;
}

export default App;
